import React from 'react';

import InfoIcon from 'react-icons/lib/md/info-outline';
import Tooltip from 'react-tt';

import { Text } from 'wanderu-components';
import type { I18nMoneyFunction } from 'wanderu-i18n';
import { localize } from 'wanderu-i18n';

import { LineItem } from '../../LineItem';

import styles from './Fees.scss';

import type { TFunction } from 'i18next';

interface FeeLineItemWithTooltipProps {
    description: string;
    label: string;
    pricing: string;
}

const FeeLineItemWithTooltip = ({ description, label, pricing }: FeeLineItemWithTooltipProps) => {
    const LeftColumn = () => (
        <div className={styles.leftColumn}>
            <Text component="div" variant="text-s">
                {label}
            </Text>
            <div className={styles.container}>
                <Tooltip id="tooltip">
                    <div className={styles.tooltipContent}>
                        <Text component="div" variant="text-xs">
                            {description}
                        </Text>
                    </div>
                </Tooltip>
                <InfoIcon className={styles.infoIcon} />
            </div>
        </div>
    );

    return (
        <LineItem
            leftCol={<LeftColumn />}
            rightCol={pricing}
        />
    );
};

interface FeesProps {
    fees: {
        id: string;
        label: string;
        pricing: Record<string, number>;
    }[],
    i18nMoney: I18nMoneyFunction,
    t: TFunction,
}

function Fees({ fees, i18nMoney, t }: FeesProps) {
    const feesToDisplay = fees.filter(fee => i18nMoney([fee.pricing]).getTotalPrice() !== 0 && !fee.id.includes('wanderu_discount'));
    const discountFee = fees.find(fee => fee.id.includes('wanderu_discount'));
    const discount = discountFee?.pricing;

    return (
        <div className={styles.fees}>
            {feesToDisplay.map((fee) => {
                if (fee.id === 'wanderu_booking_fee') {
                    return (
                        <FeeLineItemWithTooltip
                            description={t('platform-fees-description')}
                            key={fee.id}
                            label={t(fee.label)}
                            pricing={i18nMoney.format(
                                i18nMoney([fee.pricing]).getTotalPrice(),
                            )}
                        />
                    );
                }

                return (
                    <LineItem
                        key={fee.id}
                        leftCol={t<string>(fee.label)}
                        rightCol={i18nMoney.format(
                            i18nMoney([fee.pricing]).getTotalPrice(),
                        )}
                    />
                );
            })}
            {discount
                ? <LineItem
                    leftCol={<Text className={styles.discount}>Wanderu Exclusive</Text>}
                    rightCol={
                        <Text className={styles.discount}>
                            {i18nMoney.format(i18nMoney([discount]).getTotalPrice())}
                        </Text>
                    }
                />
                : ''}
        </div>
    );
}

export default localize(Fees, ['i18nMoney', 't'], 'baseApp');
